import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import VerifyCode from "../pages/auth/VerifyCode";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Dashboard from "../pages/dashboard/Dashboard";
import WalletDashboard from "../pages/wallet/WalletDashboard";
import MyIps from "../pages/myips/MyIps";
import KycPage from "../pages/kyc/index";
import MerchantProfile from "../pages/profile/MerchantProfile";
import WhitelistedBankAccounts from "../pages/WhitelistedBanks";
import ServiceAccessControl from "../pages/Services";
import MyService from "../pages/MyService";
import TransactionLedger from "../pages/Transaction";
import TransactionDetails from "../pages/Transaction/TransactionDetails";
import Activity from "../pages/Activity";
import GSTInvoices from "../pages/GSTInvoices";
import ComplaintsDashboard from "../pages/Complaints";
import FundRequest from "../pages/FundRequest";
import ApiKeyPage from "../pages/ApiKey";
import RevokedApiKeyPage from "../pages/ApiKey/RevokedApiKey";
import Reports from "../pages/Reports";
import ApiDocs from "../pages/ApiKey/ApiDocs";
import OnboardMerchant from "../pages/onboard/OnboardMerchant";
import AppShell from "../components/layout/AppShell";
import { useKyc } from "../context/KycContext";

function GuestGuard() {
  const token = localStorage.getItem("token");
  if (token) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

function AuthGuard() {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function KycGuard() {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  const { isRestricted, initializing } = useKyc();
  if (initializing) return <Outlet />;
  if (isRestricted) return <Navigate to="/kyc" replace />;
  return <Outlet />;
}

function OnboardGuard() {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  const { kycStatus, initializing } = useKyc();
  if (initializing) return <Outlet />;
  const isFullySubmitted = kycStatus?.kyc_submitted && kycStatus?.documents_submitted;
  const isReKyc = kycStatus?.kyc_status === "rejected" || kycStatus?.kyc_status === "re_kyc";
  const isReupload = kycStatus?.reupload_request?.status === "pending";
  if (isFullySubmitted && !isReKyc && !isReupload) return <Navigate to="/kyc" replace />;
  return <Outlet />;
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes — no shell */}
        <Route element={<GuestGuard />}>
          <Route path="/"                 element={<Login />} />
          <Route path="/login"            element={<Login />} />
          <Route path="/auth/login"       element={<Login />} />
          <Route path="/register"         element={<Register />} />
          <Route path="/auth/register"    element={<Register />} />
          <Route path="/verify-code"      element={<VerifyCode />} />
          <Route path="/auth/verify-code" element={<VerifyCode />} />
          <Route path="/forgot-password"  element={<ForgotPassword />} />
        </Route>

        {/* All protected routes inside AppShell — sidebar+navbar persist */}
        <Route element={<AuthGuard />}>
          <Route element={<AppShell />}>

            {/* Always accessible */}
            <Route path="/kyc"     element={<KycPage />} />
            <Route path="/profile" element={<MerchantProfile />} />

            {/* Onboard guard */}
            <Route element={<OnboardGuard />}>
              <Route path="/onboard" element={<OnboardMerchant />} />
            </Route>

            {/* KYC restricted */}
            <Route element={<KycGuard />}>
              <Route path="/dashboard"           element={<Dashboard />} />
              <Route path="/wallet"              element={<WalletDashboard />} />
              <Route path="/myips"               element={<MyIps />} />
              <Route path="/services"            element={<ServiceAccessControl />} />
              <Route path="/my-service"          element={<MyService />} />
              <Route path="/transactions"        element={<TransactionLedger />} />
              <Route path="/transaction-details" element={<TransactionDetails />} />
              <Route path="/activity"            element={<Activity />} />
              <Route path="/complaints"          element={<ComplaintsDashboard />} />
              <Route path="/gst-invoices"        element={<GSTInvoices />} />
              <Route path="/fund-request"        element={<FundRequest />} />
              <Route path="/api-key"             element={<ApiKeyPage />} />
              <Route path="/api-key/revoked"     element={<RevokedApiKeyPage />} />
              <Route path="/api-docs"            element={<ApiDocs />} />
              <Route path="/whitelisted-banks"   element={<WhitelistedBankAccounts />} />
              <Route path="/reports"             element={<Reports />} />
            </Route>

          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
